







































import VueOptions from '@utils/VueOptions'
import Back from '@modules/ui/buttons/Back'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import RequestButton from '@/components/RequestButton'
import Validator from '@utils/validator'

settings =
  name: 'OrganizerPassword'
  components: { Back, SuperContainerView, RequestButton }
  resources:
    organizer:
      resourceName: 'organizer'
      slug: "organizers/:organizerId"
  vue:
    props: ['organizerId']

    data: ->
      formErrors: {}
      password: '',
      password_confirmation: ''

    computed:
      hasFormErrors: -> !!Object.values(@formErrors).length

    methods:
      clearFormErrorKey: (key) ->
        @formErrors ||= {}
        @formErrors[key] = null

      validateForm: ->
        errors = {}
        errors.password = 'Password is not valid' unless Validator.isPasswordValid @password
        errors.password_confirmation = 'Passwords don\'t match' unless @password is @password_confirmation
        @formErrors = errors

      onSave: (item) -> @$router.push({ name: 'OrganizerShowPage', params: { organizerId: item.id } })

      hiSave: ->
        @validateForm()
        return if @hasFormErrors
        payload =
          id: @organizerId
          password: @password
          password_confirmation: @password_confirmation
        @save("organizers/#{@organizerId}/change_password", 'organizer', payload)

export default VueOptions.vue settings
